import { render } from "./App.vue?vue&type=template&id=ae5113bc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ae5113bc&lang=css"
script.render = render

export default script